module.exports = __webpack_public_path__ + "img/오미자믹스마케팅사례.310ccd83.png";